
	function PageForm(options){
		this.className			= "PageForm";

		this.name				= "";
		this.templateBase 		= "/forms/";

		this.reset()
	};

	PageForm.prototype.setup = function(settings = {}){

		this.templates = {};

		this.reset();

		this.settings = settings;

		this.$body = $("body");
		this.$htmlBody = $("html, body");

		if(settings.values) this.values = settings.values;
        this.recaptcha = settings?.recaptcha || false;

		this.$form = settings.$form ? settings.$form : $(".js-form");
		this.$content = settings.$content ? settings.$content : this.$form.find(".js-form-content");

		// Submit is handled via AJAX; prevent native POST (e.g. Enter key in a text field).
		this.$form.on("submit", Igloo.$d(this, this.submit));
		this.$form.find(".js-form-submit").on("click",Igloo.$d(this,this.submit));
		this.$form.find(".js-form-back").on("click",Igloo.$d(this,this.previousPage));

		this.controller = settings.controller;

		if(settings.data){
			this.data = settings.data;
		}

		if(settings.analytics){
			//Igloo.log(settings.analytics);
			var category = settings.analytics.category;
			var label = settings.analytics.label;
			if(category && label) this.sendAnalytics(category, label);
		}

		this.currentPage = 0;
		this.render().then(Igloo.delegate(this,function(){

			//Preload other pages
			for (var i = 1; i < this.data.pages.length; i++) {
				var page = this.data.pages[i];
				this.loadTemplate(this.processPage(page));
			}
		}));

	}

    PageForm.prototype.setupRecaptcha = function() {
        if(!window.grecaptcha || !this.recaptcha) return;

        if (!this.recaptcha.input) this.recaptcha.input = "recaptcha_response";

        let $recaptcha = this.$form.find('#recaptcha');
        if (!$recaptcha.length) {
            $recaptcha = $('<div id="recaptcha" class="g-recaptcha" />');
            this.$form.append($recaptcha);
        }
        this.recaptcha.$element = $recaptcha;

        this.recaptcha.loaded = true;
    }

    PageForm.prototype.getRecaptchaToken = function() {
        return new Promise((resolve, reject) => {

            // Reset any previous token
            if (typeof this.recaptcha.widgetId !== "undefined") {
                grecaptcha.reset(this.recaptcha.widgetId);
            }

            this.recaptcha.widgetId = grecaptcha.render(this.recaptcha.$element[0], {
                'sitekey': this.recaptcha?.sitekey,
                'size': 'invisible',
                'callback': resolve,
                'error-callback': reject
            });

            grecaptcha.execute(this.recaptcha.widgetId);
        });
    }
    PageForm.prototype.refreshRecaptchaToken = async function() {
        if(!window.grecaptcha || !this.recaptcha) return false;

        this.setupRecaptcha();

        var token = false;

        try {
            token = await this.getRecaptchaToken();
            console.log("Got fresh token:", token);
        } catch (err) {
            console.error("reCAPTCHA failed", err);
        }

        return token;
    }

    PageForm.prototype.sendAnalytics = function (category, label) {
        if (typeof (ga) === "undefined") return false;
        //Igloo.log("sending analytics");
        ga('send', 'event', {
			eventCategory: category,
			eventAction: 'click',
			eventLabel: label
		});
	}

	PageForm.prototype.nextPage = function(cancelOnComplete){

		if(this.currentPage < this.data.pages.length -1){
			this.currentPage++;
			this.render();
		}else if(cancelOnComplete){
			this.cancel();
		}

	}
	PageForm.prototype.previousPage = function(){
		if(this.currentPage > 0){
			this.currentPage--;
			this.render();
		}
	}
	PageForm.prototype.processPage = function(rawPage){

		const page = Object.assign({},rawPage);

		const filename 		= page.name;
		const folder		= this.folder || this.name || "";
		const uri	= this.templateBase + (folder?folder+"/":"") + filename;

		if(!page.static) page.static = true; //Assume static from now on (which means available as template, without needing to be powered by php)
		if(!page.templatePath) page.templatePath = uri;

		return page;
	}
	PageForm.prototype.render = function(){

        // GOING WRONG HERE AFTER FAILED SUBMISSION

		this.hidePage();

		this.page = this.processPage(this.data.pages[this.currentPage]);

		this.page.status = "loading";

		return this.loadTemplate(this.page).then(Igloo.delegate(this,function(template){
			this.page.template = template;
			this.page.status = "loaded";

			var handlebar 	= Handlebars.compile(template.html);
			template.compiled = handlebar(Object.assign({},this.page.labels,this.values));
            // console.log(template.compiled);

			this.$content.html(template.compiled);
			this.page.status = "visible";
			this.initPage();
		}));

	}
	PageForm.prototype.hidePage = function(){
		if(!this.page) return;

		this.page.status = "off";
		if(this.page.destroy) this.page.destroy();
		//this.$title.text("");
	}
	PageForm.prototype.loadTemplate = function(page){
		const post 		= page.post;
		const uri		= page.templatePath;

		let template 	= this.templates[uri];

		if(template && (!post || page.static)){
			return template.promise
		}else{
			template = {};
			template.uri = uri;

			var dfd = jQuery.Deferred();
			var promise = dfd.promise();
			template.promise = promise;

			//Try loading from meta template (when still not post)
			let metaTemplate;
			if(!post  || page.static){
				metaTemplate = StandardController.getTemplate(uri.replace(/^\//, '')); //form id has no leading slash
			}


			if(metaTemplate){
				//Found embeded in the page
				template.html = metaTemplate;
				template.status = "loaded";
				dfd.resolve(template);
			}else{
				//Load it in
				template.ajax = $.ajax({
					url: uri//,
					//method: post && Object.keys(this.values).length  ? "post" : "get",
					//data: this.values
				}).then(function(html,status,e){
					template.html = html;
					template.status = "loaded";
					dfd.resolve(template);
				},function(e){
					template.html = "error";
					template.status = "error";
					dfd.resolve(template);
				})
			}

			this.templates[uri] = template;

			return template.promise;
		}


	}
	PageForm.prototype.initPage = function(e){

        // console.log(this.page);

		var p = this.page;

		this.page.$errors 	= this.$content.find(".js-form-errors");
		this.page.$submit 	= this.$content.find(".js-form-submit").on("click",Igloo.$d(this,this.submit));
		this.page.$back 	= this.$content.find(".js-form-back").on("click",Igloo.$d(this,this.previousPage));

		if(this.page.onRender){
			$template = this.$content;
			this.page.onRender($template);
		}

		var updateGeneric = Igloo.delegate(this,function(i){

			i.empty = !i.value || i.value === "";

			var validationFunction = i.validation ? this[i.validation + "Validation"] : false;
			var validObject = validationFunction ? validationFunction(i.value,{required: i.required}) : (!i.required || !i.empty);
			if(validObject === true || validObject === false) validObject = {valid: validObject};

			i.valid = validObject.valid;

			i.error = !!i.edited && !i.valid;
			// Keep the validator's message for display when submission is blocked.
			i.errorMessage = validObject.msg || false;
			i.$wrapper.toggleClass( "valid", i.valid );
			i.$wrapper.toggleClass( "error", i.error );
			i.$wrapper.toggleClass( "focus", i.focus );
			i.$wrapper.toggleClass( "empty", i.empty);
        });


		var $inputs = this.$content.find("input, select, textarea, .js-buttons");

		var inputs = [];
        $inputs.each((index, input) => {
            let $input = $(input);
            const $wrapper = $input.closest(".js-form-item").length ? $input.closest(".js-form-item") : $input;

            let $choices = null;
            const type = $input.attr('data-input_type') || $input.attr('type');
            let field = $input.hasClass("js-buttons") ? "buttons" : "input";
            if(type === "checkbox" || type === "radio") field = "choice";

            // For checkbox/radio groups, only create one entry per name
            if (field === "choice") {
                let existing = inputs.find(i => i.name === $input.attr("name"));
                if (existing) return existing.$input = existing.$input.add($input); // group inputs
                $choices = $inputs.filter(`input[name="${$input.attr("name")}"]`)
            }

            const i = {
                $input: $choices || $input,
                $wrapper,
                name: $input.attr("name"),
                type,
                field,
                required: $input.hasClass("required") || $wrapper.hasClass("required"),
                options: [],
                value: "",
                empty: true,
                edited: false,
                focus: false,
            };

            if(field === "input"){
                if (type === "file") this.setupUpload(i);
                if (type === "email" || $input.hasClass("email") || $wrapper.hasClass("email")) i.validation = "email";
                if (type === "textarea") {
                    $input.css({ height: `${input.scrollHeight}px`, overflowY: 'hidden' });
                    $input.on('input', (e) => {
                        const $t = $(e.currentTarget);
                        $t.css('height', 0).css('height', $t.prop("scrollHeight"));
                    });
                }

                // Update function
                i.update = function(forceChange = false) {
                    if (!i.edited && forceChange) i.edited = true;

                    i.value = i.$input.val();
                    i.focus = i.$input.is(":focus");
                    i.empty = i.$input.is(":empty");

                    updateGeneric(i);
                };

                // Set function
                i.set = function(value) {
                    i.$input.val(value);
                    i.update();
                };

                i.$input.on("input focus", () => i.update());
                i.$input.on("blur", () => i.update(true));
            }

            if(field === "choice"){

                // Update function
                i.update = function(forceChange = false) {
                    if (!i.edited && forceChange) i.edited = true;

                    const selected = i.$input.filter(":checked").map((_, e) => $(e).val()).get();

                    i.focus = i.$input.is(":focus");
                    i.value = selected.join("; ");
                    i.empty = selected.length === 0;

                    updateGeneric(i);
                };

                // Set function
                i.set = function(value) {
                    i.$input.each((_, e) => {
                        $(e).prop("checked", value.split("; ").includes($(e).val()));
                    });
                    i.update();
                };

                i.$input.on("click", () => i.update(true));
            }

            if(field === "buttons"){
                i.multiple = $input.hasClass("multiple");

                var $buttons = $input.find("a[name]");
                i.$buttons = $buttons;
                i.update = function(edited) {
                    var $selected = $buttons.filter(".selected");
                    i.value = $selected.length ? $selected.map(function(){ return $(this).attr("name")}).get().join("; ") : "";
                    if (edited) i.edited = true;
                    updateGeneric(i);
                }

                i.set = Igloo.delegate(this,function(value, options){

                    //Check to reload the buttons in case they changed
                    var $buttons = $input.find("a[name]");
                    i.$buttons = $buttons;


                    if(!options) options = {};
                    var manual = options.manual;
                    var state = Igloo.defined(options.state) ? options.state : true;

                    if(!i.multiple) $buttons.removeClass("selected").removeClass("selected");

                    var $button = $buttons.filter("[name='"+value+"']");

                    var isSelected = $button.hasClass("selected");
                    if(state === true || (state == "toggle" && !isSelected)) $button.addClass("selected").addClass("selected");
                    if(state === false || (state == "toggle" && isSelected)) $button.removeClass("selected").addClass("ignore-hover").removeClass("selected").addClass("ignore-hover");


                    i.update();
                    if(manual && this.page.instant){
                        setTimeout(Igloo.delegate(this,function(){
                            if(this.checkPage(false)){
                                this.submit();
                            }
                        }),Igloo.isiOS() ? 100 : 0);

                    }
                });


                if(Igloo.isiOS()) $buttons.addClass("ignore-hover").addClass("ignore-hover");

                $buttons.on("click",Igloo.$d(this,function($this,e){

                    i.set($this.attr("name"), {manual: true, state: "toggle"});

                }));


                $buttons.on("mouseover",Igloo.$d(this,function($this){
                    $this.addClass("over").removeClass("ignore-hover").addClass("over").removeClass("ignore-hover");
                }));
                $buttons.on("mouseout",Igloo.$d(this,function($this){
                    $this.removeClass("over").removeClass("ignore-hover").removeClass("over").removeClass("ignore-hover");
                }));


            }

            i.update();
            inputs.push(i);
        });


        console.log(inputs);
		this.page.inputs = inputs;

		this.loadDefaults();

		if(this.page.init) this.page.init();
		//this.open();
	}
	PageForm.prototype.loadDefaults = function(){
		//Load defaults / already set values
		if(!this.page || !this.page.inputs) return;
		for (var i = 0; i < this.page.inputs.length; i++) {
			var input = this.page.inputs[i];
			var value = this.values[input.name];

            if (input.field === "choice") {
                const selected = input.$input.filter(":checked").map((_, e) => $(e).val()).get();
                value = selected.length ? selected.join("; ") : value;
            }

            if (value) input.set(value);
		}
		if(this.page.instant && this.checkPage(false)) this.checkPage(true);
	}
	PageForm.prototype.emailValidation = function(value, settings){

		if(!settings) settings = {};

		// Client-side check for immediate feedback; PHP validates again on submission.
		value = $.trim(value || "");

		if(!value) {
			return settings.required
				? {valid: false, msg: "Please enter your email address."}
				: true;
		}

		var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
		return valid ? true : {valid: false, msg: "Please enter a valid email address."};

	}

	/*
	 * File uploads
	 */
	PageForm.prototype.setupUpload = function(d){

		this.currentUploads = 0;
		this.submitWaitingOnUploads = 0;

		var btn 		= d.$holder.find(".uploadBtn")[0],
		progressBar 	= d.$holder.find(".progressBar")[0],
		progressOuter 	= d.$holder.find(".progressOuter")[0],
		msgBox 			= d.$holder.find(".msgBox")[0];
		// itemID			= btn.getAttribute("data-itemid");

		d.files = [];
		d.$fileArea = d.$holder.find(".fileArea");

		var _this		= this;
		var uploadURL 	= "&upload=1";
		if(this.page.submissionUrl) uploadURL = this.page.submissionUrl + uploadURL;

		var initialButtonHTML = false;

		var uploader = new ss.SimpleUpload({
			dropzone: d.$holder.attr("id"),
			button: btn,
			url: uploadURL,
			name: 'uploadfile',
			multipart: true,
			hoverClass: 'hover',
			focusClass: 'focus',
			responseType: 'json',
			startXHR: function() {
				progressOuter.style.display = 'block'; // make progress bar visible
				this.setProgressBar( progressBar );
			},
			onSubmit: function() {
				msgBox.innerHTML = '0%'; // empty the message box
				initialButtonHTML = btn.innerHTML; // change button text to "Uploading..."
				btn.innerHTML = 'Uploading...'; // change button text to "Uploading..."
				_this.currentUploads++;
				d.status = "busy";
			},
			onProgress: function(percent){
				msgBox.innerHTML = percent+'%';
			},
			onComplete: function( filename, response ) {
				btn.innerHTML = 'Add another file';
				msgBox.innerHTML = '';
				progressOuter.style.display = 'none'; // hide progress bar when upload is completed
				_this.currentUploads--;
				d.status = "complete";
				if ( !response ) {
					msgBox.innerHTML = 'Unable to upload file';
					return;
				}

				if ( response.success === true ) {
					msgBox.innerHTML = '';//'<strong>' + _this.escapeTags( filename ) + '</strong>' + ' successfully uploaded.';
					if(_this.submitWaiting){
						alert("sumbmitimsdf")
					}
					response.originalFilename = filename;
					_this.addFile(d,response);
					d.$holder.removeClass('error');
				} else {
					if ( response.msg )  {
						msgBox.innerHTML = _this.escapeTags( response.msg );

					} else {
						msgBox.innerHTML = 'An error occurred and the upload failed.';
					}
				}
			},
			onError: function(a,b,c,d,e,f) {
				//Igloo.log(a)
				//Igloo.log(b)
				//Igloo.log(c)
				//Igloo.log(d)
				//Igloo.log(e)
				//Igloo.log(f)
				//Igloo.log(this)
				d.status = "complete";
				_this.currentUploads--;
				progressOuter.style.display = 'none';
				msgBox.innerHTML = 'Unable to upload file';
			}
		});
	};
	PageForm.prototype.escapeTags = function(str){
		return String( str )
			.replace( /&/g, '&amp;' )
			.replace( /"/g, '&quot;' )
			.replace( /'/g, '&#39;' )
			.replace( /</g, '&lt;' )
			.replace( />/g, '&gt;' );
	};
	PageForm.prototype.addFile = function(d, response){
		var f = {};
		f.originalFilename 	= response.originalFilename;
		f.filename 			= response.filename;

		d.$fileArea.append("<div class='file'><span class=''>"+this.escapeTags(f.originalFilename )+"</span> <a href='#remove' class='remove'>(remove)</a></div>");
		f.$element 	= d.$fileArea.find("div.file:last");
		f.$remove	= f.$element.find("a.remove");

		var _this = this;
		f.$remove.on("click",function(e){
			e.preventDefault();
			_this.removeFile(d, f.filename);
		});

		d.files.push(f);
		this.refreshFileList(d);
	};
	PageForm.prototype.removeFile = function(d, filename){
		var index = Igloo.isIn(d.files,"filename",filename);
		if(index !== false){
			var f = d.files[index];
			f.$element.remove();
			d.files.splice(index,1);
		}
		this.refreshFileList(d);
	};
	PageForm.prototype.refreshFileList = function(d){
		var str = "";
		for(var i = 0 ; i < d.files.length; i++){
			str += (str?",":"")+ d.files[i].filename;
		}
		d.$input.val(str);
	};
	PageForm.prototype.submit = function(e){
		if(this.page.submit) this.page.submit();
		this.checkPage(true);
	};
	PageForm.prototype.checkPage = function(hard){
        this.hideError();

		var errors = [];

        for(var i in this.page.inputs){

			var input = this.page.inputs[i];

			input.update(hard);
			var value = input.value;
			if(!input.valid) errors.push({
				input: input,
				msg: input.errorMessage
			})
		}

		if(!hard) return !errors.length;


		if(errors.length){
			// Messages are plain text, so do not add HTML line breaks.
			var messages = [];
			for (var i = 0; i < errors.length; i++) {
				var e = errors[i];
				if(e.msg) messages.push(e.msg);
			}
			this.showError(messages.join(" "));
			this.scrollToInput(errors[0].input);
		}else{
			let inputs = [];

            for(var index in this.page.inputs){
				var input = this.page.inputs[index];
				this.values[input.name] = input.value;
			}

			// console.log(this.values);
			this.continue();
		}

	}
	PageForm.prototype.scrollToInput = function(input){
		if(!input || !input.$wrapper || !input.$wrapper.length) return;

		var $focusTarget = input.$input.filter(":visible").first();
		var header = $(".js-site-header .site-header__backdrop").first()[0];
		var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
		var scrollTop = Math.max(0, input.$wrapper.offset().top - headerBottom - 32);
		var reduceMotion = window.matchMedia
			&& window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		// Scroll to the first invalid field, then move keyboard focus to it.
		this.$htmlBody.stop(true).animate({scrollTop: scrollTop}, reduceMotion ? 0 : 300, function(){
			if(!$focusTarget.length) return;
			try {
				$focusTarget[0].focus({preventScroll: true});
			} catch(e) {
				$focusTarget[0].focus();
			}
		});
	}
	PageForm.prototype.showError = function(msg){
		this.page.$errors.show();

		var $general = this.page.$errors.find(".js-general");
		if(!$general.length) $general = this.page.$errors.filter(".js-general");
		if(!$general.length) $general = this.page.$errors;

		var $specific = this.page.$errors.find(".js-specific");

		var generalErrorMessage = this.page?.errors?.general ? this.page.errors.general : "Sorry, there's a problem. Please check the form.";
		$general.text(generalErrorMessage).show();

		if(msg){
			// console.log(msg)
			// console.log(this.page.errors)
			const fullMessage = this.page.errors[msg] ?? msg;

			if($specific.length) $specific.text(fullMessage).show(); //If there's a place for the specific error, use it
			else $general.text(fullMessage).show(); //Otherwise set the general text to this
		}
	}
	PageForm.prototype.hideError = function(){
		this.page.$errors.hide();
		$(this.page.$errors.find(".js-general"),this.page.$errors.filter(".js-general")).text("")
		this.page.$errors.find(".js-specific").text("")
	}
	PageForm.prototype.continue = function(){
		if(this.page.submissionUrl){
			//Submit and check
            this.send();
            this.hidePage();
		}else{
			this.nextPage(true)
		}

	}
	PageForm.prototype.send = async function(){
		if(this.submitting) return false;
		this.page.$submit.addClass("disabled");

        // this.$content.html(this.page.submissionText ?? "Sending...");

        // Refresh reCAPTCHA token before sending
        if (this.recaptcha) {
            var token = await this.refreshRecaptchaToken();
            this.values[this.recaptcha.input] = token;
        }

        this.submitting = true;
		$.ajax({
			url: this.page.submissionUrl,
			data: this.values,
			method: "post",
            contentType: "application/x-www-form-urlencoded",
			dataType: "json"
		}).then(Igloo.delegate(this,function(r){

			this.submitting = false;
			this.page.$submit.removeClass("disabled");
			this.page.lastResult = r;

			this.submissionResults = r;
			if(r.success){
				this.submitted = true;
				this.nextPage(true);
			}else{
				// Wait for the form to redraw before showing the server message.
				this.render().then(Igloo.delegate(this,function(){
					this.showError(r.message);
				}));
			}


		}),Igloo.delegate(this,function(){
			this.submitting = false;
			this.page.$submit.removeClass("disabled");
			this.error();
		}));

	}
	PageForm.prototype.error = function(){
		alert("There was a problem submitting your form.")
	}
	PageForm.prototype.reset = function(){
		this.values = {};
		this.currentPage = 0;
		this.page = false;
		this.submitted = false;
	}
	PageForm.prototype.resize = function(){

		if(this.page && this.page.resize) this.page.resize();

	}
	PageForm.prototype.cancel = function(e){
		this.hidePage();
		this.close();
		this.destroy();
	}
	PageForm.prototype.destroy = function(){
		this.reset();
	}

